import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { marker } from '@common/translate-marker';
import { ExtendedBaseTab } from '@common/classes/extended-base-tab';
import { StorageDocumentService } from '@common/services/storage-document.service';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { CustomExtendedTabService } from 'app/singleton-services/custom-extended-tab.service';

@Component({
    selector: 'app-documents-for-service-request-modal',
    templateUrl: './documents-for-service-request-modal.component.html',
    standalone: false
})
export class DocumentsForServiceRequestModalComponent extends ExtendedBaseTab implements OnInit {
    public title: string;
    public serviceRequestId: number;
    public shipmentId?: number;
    public shipmentDetailId?: number;

    public isBusy: boolean = false;
    private documents: any[] = [];

    constructor(
        public activeModal: DialogRef,
        private storageDocumentService: StorageDocumentService,
        private router: Router,
        customExtendedTabService: CustomExtendedTabService
    ) {
        super(customExtendedTabService);
    }

    ngOnInit(): void {
        this.isBusy = true;
        this.defaultPaging();
        this.loadDocuments();
    }

    public close(): void {
        this.activeModal.close(null);
    }

    public navigateToDocument(id: number, isAmendmentDocument: boolean): void {
        this.close();
        this.router.navigate([
            isAmendmentDocument ? '/tos-operations/amendment-document/edit' : '/tos-operations/storage-document/edit',
            id
        ]);
    }

    public getStatusClass(statusId: string): string {
        return this.resolveStatusPillClass(statusId) || 'white-pill';
    }

    private loadDocuments(): void {
        this.isBusy = true;

        this.storageDocumentService
            .getDocumentsForServiceRequest({
                serviceRequestId: this.serviceRequestId,
                shipmentId: this.shipmentId,
                shipmentDetailId: this.shipmentDetailId
            })
            .subscribe({
                next: (response) => {
                    this.documents = response.documents || [];
                    this.title = this.getModalTitle(response.isAmendmentDocuments);
                    this.loadItems(this.documents);
                    this.isBusy = false;
                },
                error: () => {
                    this.isBusy = false;
                    this.loadItems([]);
                }
            });
    }

    private getModalTitle(isAmendmentDocuments: boolean): string {
        if (this.shipmentDetailId) {
            return this.translateService.instant(
                isAmendmentDocuments
                    ? marker('Amendment Documents for Service Request Item')
                    : marker('Storage Documents for Service Request Item')
            );
        }

        if (this.shipmentId) {
            return this.translateService.instant(
                isAmendmentDocuments
                    ? marker('Amendment Documents for Service Request Shipment Item')
                    : marker('Storage Documents for Service Request Shipment Item')
            );
        }

        return this.translateService.instant(
            isAmendmentDocuments
                ? marker('Amendment Documents for Service Request')
                : marker('Storage Documents for Service Request')
        );
    }
}
